import { render, staticRenderFns } from "./Leads.vue?vue&type=template&id=3a517992&scoped=true"
import script from "./Leads.vue?vue&type=script&lang=js"
export * from "./Leads.vue?vue&type=script&lang=js"
import style0 from "./Leads.vue?vue&type=style&index=0&id=3a517992&prod&lang=scss&scoped=true"
import style1 from "./Leads.vue?vue&type=style&index=1&id=3a517992&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a517992",
  null
  
)

export default component.exports